export default __webpack_public_path__ + "static/media/icons8-crawlspace.b1005713.svg";